import styled from "styled-components";

const IconContainer = styled.span`
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  color: #acacac;
  font-size: 24px;
`;
export default IconContainer;
